import { createAction, props } from '@ngrx/store';
import { AlertNotification } from 'brain-data/model/alert.model';

export const resetAlertLoading = createAction('[Alert] Reset Alert loading');

export const resetAlertType = createAction('[Alert] Reset Alert');
export const updateAlertType = createAction('[Alert] Update Alert', props<{ alertType: string }>());

export const notifyAlert = createAction('[Alert] notify', props<{ alertId: number; alertNotification: AlertNotification }>());
export const notifyAlertSuccess = createAction('[Alert] notify success');
export const notifyAlertError = createAction('[Alert] notify error', props<{ error: Error }>());

export const snoozeAlert = createAction('[Alert] snooze', props<{ alertId: number; days: number }>());
export const snoozeAlertSuccess = createAction('[Alert] Snooze Alert Success', props<{ alertId: number; days: number }>());
export const snoozeAlertError = createAction('[Alert] snooze error', props<{ error: Error }>());

export const notifyAndSnoozeAlert = createAction('[Alert] notify and snooze', props<{ alertId: number; days: number; alertNotification: AlertNotification }>());
export const notifyAndSnoozeAlertSuccess = createAction(
  '[Alert] Notify and Snooze Alert Success',
  props<{ alertId: number; days: number; alertNotification: AlertNotification }>(),
);
export const notifyAndSnoozeAlertError = createAction('[Alert] notify and snooze  error', props<{ error: Error }>());

export const unsnoozeAlert = createAction('[Alert] unsnooze', props<{ alertId: number }>());
export const unsnoozeAlertSuccess = createAction('[Alert] Unsnooze Alert Success', props<{ alertId: number }>());
export const unsnoozeAlertError = createAction('[Alert] unsnooze error', props<{ error: Error }>());

export const closeAlert = createAction('[Alert] close', props<{ alertId: number }>());
export const closeAlertSuccess = createAction('[Alert] Close Alert Success', props<{ alertId: number }>());
export const closeAlertError = createAction('[Alert] close error', props<{ error: Error }>());

export const closeAlerts = createAction('[Alert] close batch', props<{ alertIds: number[] }>());
export const closeAlertsSuccess = createAction('[Alert] Close Alerts Success', props<{ alertIds: number[] }>());
export const closeAlertsError = createAction('[Alert] close batch error', props<{ error: Error }>());

export const reopenAlert = createAction('[Alert] reopen', props<{ alertId: number }>());
export const reopenAlertSuccess = createAction('[Alert] Reopen Alert Success', props<{ alertId: number }>());
export const reopenAlertError = createAction('[Alert] reopen error', props<{ error: Error }>());
